import { useQuery } from '@tanstack/react-query'

import { productLotApi } from '@/lib/api/product-lot-api'

export const lotDebtKeys = {
    all: ['lot-debts'] as const,
    byProduct: (productId: string) =>
        [...lotDebtKeys.all, 'by-product', productId] as const,
}

/**
 * Đơn đang nợ lô của một sản phẩm, cho khối "Bù đơn đang nợ hàng" ở màn tạo
 * phiếu nhập lô. Không có sản phẩm (dòng lô chưa chọn) thì không gọi API.
 */
export function useOpenLotDebts(productId: string | undefined) {
    return useQuery({
        queryKey: lotDebtKeys.byProduct(productId ?? ''),
        queryFn: async () => {
            const res = await productLotApi.listOpenLotDebts(productId!)
            return res.data ?? []
        },
        enabled: Boolean(productId),
    })
}
